import { axios, base } from '../http'

/**
 * 后端返回 PascalCase 字段，宠物页面统一按 camelCase 读取，这里递归转换 response。最后更新：2026-10-07
 * @param {*} value - 任意返回值
 * @returns {*}
 */
function toCamel (value) {
  if (Array.isArray(value)) return value.map(toCamel)
  if (value && typeof value === 'object') {
    return Object.keys(value).reduce((result, key) => {
      result[key.charAt(0).toLowerCase() + key.slice(1)] = toCamel(value[key])
      return result
    }, {})
  }
  return value
}

/** 包装请求：成功返回后将 data.response 转为 camelCase */
const camelize = promise => promise.then(res => {
  if (res && res.data && res.data.response !== undefined) res.data.response = toCamel(res.data.response)
  return res
})

export const getPetConfig = (params) => camelize(axios.get(`${base}/api/Pet/GetConfig`, { params }))
export const savePetConfig = (data) => axios.post(`${base}/api/Pet/SaveConfig`, data)
export const getPetList = (params) => camelize(axios.get(`${base}/api/Pet/GetList`, { params }))
export const savePet = (data) => axios.post(`${base}/api/Pet/Save`, data)
export const setPetStatus = (params) => axios.post(`${base}/api/Pet/SetStatus`, null, { params })
export const getPetStudentList = (params) => camelize(axios.get(`${base}/api/Pet/GetStudentList`, { params }))
export const exportPetStudentList = (params) => axios.get(`${base}/api/Pet/ExportStudentList`, { params, responseType: 'blob' })
export const getPetStudentDetail = (params) => camelize(axios.get(`${base}/api/Pet/GetStudentDetail`, { params }))
export const adminClaimPet = (schoolId, data) => axios.post(`${base}/api/Pet/AdminClaim?schoolId=${schoolId}`, data)
export const adminChangePet = (schoolId, data) => axios.post(`${base}/api/Pet/AdminChange?schoolId=${schoolId}`, data)
export const getPetRanking = (params) => camelize(axios.get(`${base}/api/Pet/GetRanking`, { params }))
export const exportPetRanking = (params) => axios.get(`${base}/api/Pet/ExportRanking`, { params, responseType: 'blob' })
export const getPetConfigChangeLogList = (params) => camelize(axios.get(`${base}/api/Pet/GetConfigChangeLogList`, { params }))
export const exportPetConfigChangeLogList = (params) => axios.get(`${base}/api/Pet/ExportConfigChangeLogList`, { params, responseType: 'blob' })
export const getPetStatistics = (params) => camelize(axios.get(`${base}/api/Pet/GetStatistics`, { params }))
export const deletePet = (params) => axios.post(`${base}/api/Pet/Delete`, null, { params })
export const getPetSemesterList = (params) => camelize(axios.get(`${base}/api/Pet/GetSemesterList`, { params }))
export const getPetChangeLogList = (params) => camelize(axios.get(`${base}/api/Pet/GetChangeLogList`, { params }))
export const exportPetChangeLogList = (params) => axios.get(`${base}/api/Pet/ExportChangeLogList`, { params, responseType: 'blob' })
export const batchClaimPet = (schoolId, data) => camelize(axios.post(`${base}/api/Pet/BatchClaim?schoolId=${schoolId}`, data))
/** 复制宠物到其他学校（仅 admin / blogadmin）。创建于 2026-11-04 */
export const copyPetsToSchool = (data) => camelize(axios.post(`${base}/api/Pet/CopyToSchool`, data))

